import _ from 'lodash'

export const sliderValues = (state, input) => ({
  motorFinanceMonthlyPrice: _.get(input, 'monthlyPrice'),
  motorFinanceCash: _.get(input, 'cash'),
  motorFinanceTime: _.get(input, 'months'),
  motorFinanceResidualValue:
    (_.get(input, 'salvageValue', 0) / 100) *
    _.get(state.classified.requestedAd, 'ad.price.value', 0),
  motorFinanceRestrictedResidualValue:
    (_.get(input, 'calculatedMaxSalvageValue', 0) / 100) *
    _.get(state.classified.requestedAd, 'ad.price.value', 0),
  motorFinanceCreditCost: _.get(input, 'creditCost'),
  motorFinanceEffectiveRate: _.round(Number(_.get(input, 'effectiveRate', 0)) / 100, 4),
})
